import config from '@/config';
import { LogicContext } from '@/logic/main/types';
import { getProductContext } from '@/logic/main/utils';
import models from '@/model';
import { getLocale } from '@/utils';

export const fetchShuffleGames = (
  context: LogicContext,
  event: { type: string; payload: { [key: string]: any } }
) => async () => {
  const authToken = context.user?.authToken?.access_token;
  const product = getProductContext();
  const behaviour = event.payload?.behaviour;
  const limit = event.payload?.limit;
  const uid = event.payload?.uid;

  if (product && authToken) {
    const { status, data } = await models.fetchShuffleGames({
      authToken,
      title: product,
      locale: getLocale(config),
      market_country: config.viewer_country,
      market_region: config.viewer_region,
      behaviour,
      limit,
      uid,
    });

    return {
      status,
      shuffleGames: data,
    };
  }

  console.error(
    'There was a problem while fetching Shuffled Games. Undefined product name or authToken.'
  );
  return {
    status: 400,
    shuffleGames: [],
  };
};
